import React from "react";
import ModalPopupComponent from "../../ModalPopupComponent/theme11/ModalPopupComponent";
import LoginPopup from "./login/loginform";
import RegisterForm from "./Registration/registration";
import VendorLoginPopup from "./venderLogin/loginForm";
import { withRouter } from "next/router";
import { tokenExpiry } from "../../../../common/lib/tokenExpiry";
import Logout from "./logout";
let hasRunResetTokenCheck = false;
class Theme1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupType: props.data.directOpenLinkPopup || "LoginWithMobile",
      isCheckingResetToken: false,
      forgotPasswordEmail: "",
      forgotPasswordErr: "",
      verifyOtpMobile: undefined,
      popupPage: props.data.directOpenLinkPopup.popupPage || "LoginWithMobile",
      popupCompoenet:
        props.data.directOpenLinkPopup.popupCompoenet || "LoginWithMobile",
      showPopup: false,
    };
  }

  componentDidMount() {
    const currentPath = window.location.pathname;

    if (!localStorage.getItem("loginReferrer")) {
      localStorage.setItem("loginReferrer", currentPath);
    }
    if (!hasRunResetTokenCheck) {
      hasRunResetTokenCheck = true;
      this.checkResetToken();
    }
  }


  componentDidUpdate(prevProps) {
    if (
      prevProps.data.directOpenLinkPopup !== this.props.data.directOpenLinkPopup
    ) {
      this.setState({
        popupType: this.props.data.directOpenLinkPopup || "LoginWithMobile",
        popupPage:
          this.props.data.directOpenLinkPopup?.popupPage || "LoginWithMobile",
        popupCompoenet:
          this.props.data.directOpenLinkPopup?.popupCompoenet || "login",
      });
    }
  }


  checkResetToken = () => {
    const { router, data } = this.props;
    const { query } = router || {};
    const token = query?.resettoken || query?.createtoken;

    if (!token) return;

    this.setState({ isCheckingResetToken: true });

    const payload = {
      resettoken: token,
      site_id: data?.home?.data?.site?.id,
    };

    if (typeof tokenExpiry === "function") {
      tokenExpiry(payload).then((resp) => {
        const isValid = resp?.data?.status;
        if (isValid) {

          this.setState({
            popupType: query?.resettoken ? "ResetPassword" : "resettokenExpiry",
            popupPage: query?.resettoken ? "ResetPassword" : "resettokenExpiry",
            popupCompoenet: "login",
            isCheckingResetToken: false,
            showPopup: true,
          });
        } else {
          this.setState({
            isCheckingResetToken: false,
            showPopup: false,
            popupCompoenet: "login",
            popupType: "tokenExpired",
            popupPage: "tokenExpired",
          });
        }
      });
    } else {
      console.error("tokenExpiry is not a function");
    }
  };

  openLoginPopup = () => {
    this.setState({
      popupType: "LoginWithMobile",
      popupCompoenet: "login",
      popupPage: "LoginWithMobile",
    });
    // if (this.props.data.onClickCross) {
    //   this.props.data.onClickCross();
    // }
  };

  openRegisterPopup = () => {
    this.setState({
      popupType: "Register",
      popupCompoenet: "Register",
      popupPage: "Register",
    });
    if (this.props.data.onClickCross) {
      this.props.data.onClickCross();
    }
  };

  render() {
    const {
      logincss: styles,
      modalCss,
      basiccss,
      isMobile,
      onClickCross,
      isPopup,
    } = this.props.data;
    const shouldShowPopup = isPopup !== undefined ? isPopup : true;
    const handlers = {
      setPopupType: (type, data) => {
        // If type is an object, treat as { popupCompoenet, popupPage, ... }
        if (typeof type === "object" && type !== null) {
          this.setState({
            popupType:
              type.popupPage || type.popupCompoenet || "LoginWithMobile",
            popupCompoenet: type.popupCompoenet || "login",
            popupPage: type.popupPage || "LoginWithMobile",
            verifyOtpMobile: type.verifyOtpMobile || undefined,
          });
        } else if (type === "VerifyOTP" && data) {
          this.setState({
            popupType: type,
            verifyOtpMobile: data,
            popupCompoenet: "login",
            popupPage: type,
          });
        } else {
          this.setState({ popupType: type });
        }
      },
      onChangeForgotPassEmail: this.onChangeForgotPassEmail,
      onClickForgotSubimitBtn: this.onClickForgotSubimitBtn,
      onClickCross: onClickCross,
    };

    const currentPopupType = {
      popupPage: this.state.popupPage,
      popupCompoenet: this.state.popupCompoenet,
    };
    const router = this.props.router;
    const hasResetToken =
      router &&
      router.query &&
      (
        (router.query.resettoken && router.query.resettoken !== "" && router.query.resettoken !== null) ||
        (router.query.createtoken && router.query.createtoken !== "" && router.query.createtoken !== null)
      );
    // If reset token is present, always show ResetPassword
    if (this.state.isCheckingResetToken) {
      return <div />; // or a loader/spinner if you want
    }
    return (
      <div
        className={
          currentPopupType.popupCompoenet === "Register"
            ? styles?.basiccss.signup_main_container
            : currentPopupType.popupCompoenet === "logout"
              ? styles?.basiccss.logout_main_container
              : styles?.basiccss.login_main_container
        }
      >
        <ModalPopupComponent
          isMobile={isMobile}
          isPopup={shouldShowPopup}
          onClosePopup={handlers.onClickCross}
          modalCss={modalCss}
          showCrossButton={true}
        >
          {hasResetToken && currentPopupType.popupCompoenet === "login" ? (
            <LoginPopup
              state={this.state}
              isMobile={isMobile}
              styles={styles.loginfilecssTheme11}
              PromotionBannerCss={styles.PromotionBannerCss}
              siteData={this.props?.data?.siteData}
              props={this.props}
              handlers={handlers}
              popupType={currentPopupType}
              verifyOtpMobile={this.state.verifyOtpMobile}
              isdDropdownStyles={styles.isdDropdownStyles}
              router={router}
            />
          ) : currentPopupType.popupCompoenet === "Register" ? (
            <RegisterForm
              isOpen={shouldShowPopup}
              onClose={handlers.onClickCross}
              userType={this.props.data.userType}
              styles={styles.registercssTheme11}
              dropDownStyles={styles.dropdownStyles}
              isdDropdownStyles={styles.isdDropdownStyles}
              titledropdownStyles={styles.titledropdownStyles}
              openLoginPopup={this.openLoginPopup}
              PromotionBannerCss={styles.PromotionBannerCss}
              datepicker={styles.datepicker}
              {...this.props}
            />
          ) : currentPopupType.popupCompoenet === "vendor_login" ? (
            <VendorLoginPopup
              isMobile={isMobile}
              state={this.state}
              styles={styles.vendorfilecssTheme11} // Use a vendor-specific style if you have one
              PromotionBannerCss={styles.PromotionBannerCss}
              siteData={this.props?.data?.siteData}
              props={this.props}
              handlers={handlers}
              popupType={currentPopupType}

            // Add any other props VendorLogin needs
            />
          ) : currentPopupType.popupCompoenet === "logout" ? (
            <Logout onClose={handlers.onClickCross} styles={styles.basiccss} />
          ) : (
            <LoginPopup
              isMobile={isMobile}
              state={this.state}
              styles={styles.loginfilecssTheme11}
              PromotionBannerCss={styles.PromotionBannerCss}
              siteData={this.props?.data?.siteData}
              props={this.props}
              handlers={handlers}
              popupType={currentPopupType}
              verifyOtpMobile={this.state.verifyOtpMobile}
              isdDropdownStyles={styles.isdDropdownStyles}
              router={router}

            />
          )}
        </ModalPopupComponent>
      </div>
    );
  }
}

export default withRouter(Theme1);
